import styled, { css } from 'styled-components';

// COLORS
import { theme } from '../../constants/theme';

//ENUMS
import { sideButton } from '../../enums/sideButton';

// INTERFACES
import { IButton } from '../../interfaces/Button.interface';

export const ButtonStyled = styled.button<IButton>`
  padding: 10px 23px 10px 18px;
  cursor: pointer;
  outline: 0;
  border: none;
  border-radius: 8px;
  font-family: "Clan Pro", sans-serif;
  font-weight: ${theme.weights.semibold};
  line-height: 24px;
  font-size: 14px;
  transition: all 0.25s;
  white-space: nowrap;
  height: 50px;
  width: 200px;
  display: flex;
  align-items: center;

  & + button {
    margin-left: 16px;
  }

  background: transparent;
  color: ${theme.colors.primary.white};
  font-size: 14px;
  line-height: 24px;


  ${({ transparent }) =>
    transparent &&
    css`
      background: ${theme.colors.primary.transparentBg};
      color: ${theme.colors.primary.black};
      font-size: 14px;
      line-height: 24px;
      border: 1px solid ${theme.colors.primary.transparentBorder};
      &:hover {
        background-color: ${theme.colors.primary.bariBlue};
        border: 1px solid ${theme.colors.primary.bariBlue};
        color: ${theme.colors.primary.white};
        & path {
          fill: ${theme.colors.primary.white};
        }
      }
    `}  

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}
    
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}


  ${({ small }) =>
    small &&
    css`
      padding: 9px 12px 9px 16px;
      position: relative;
      height: 42px;
    `}


  ${({ large }) =>
    large &&
    css`
      padding: 9px 12px 9px 16px;
      min-width: 267px;
      height: 60px;
    `}


    ${({ thin }) =>
      thin &&
      css`
        padding: 9px 12px 9px 16px;
        width: unset;
        height: 42px;
      `}    

  ${({ alert }) =>
    alert &&
    css`
      color: ${theme.colors.primary.white};
      background: ${theme.colors.secondary.red100};
      box-shadow: 0px 34px 30px -20px rgba(0, 0, 0, 0.1);
      & path {
        fill: ${theme.colors.primary.white};
      }
      &:hover {
        background-color: ${theme.colors.secondary.red300};
      }
    `}

  ${({ fixedWidth }) =>
    fixedWidth &&
    css`
      width: 240px;
    `}

  ${({ gray }) =>
    gray &&
    css`
      background-color: ${theme.colors.secondary.gray600};
      color: ${theme.colors.primary.black};
      & path {
        transition: fill 0.55s;
      }
      & circle {
        transition: fill 0.55s;
      }
      &:hover {
        color: ${theme.colors.primary.bariBlue};
        & path {
          fill: ${theme.colors.primary.white};
        }
        & circle {
          fill: ${theme.colors.primary.bariBlue};
        }
      }
    `}


${({ black }) =>
  black &&
  css`
    background: ${theme.colors.primary.black};
    color: ${theme.colors.primary.white};
    &:hover {
      background-color: ${theme.colors.primary.bariBlue};
      & rect {
        fill: ${theme.colors.primary.bariBlue};
      }
    }
    & path {
      fill: ${theme.colors.primary.white};
    }
  `}  

  ${({ outline }) =>
    outline &&
    css`
      border: 1px solid ${theme.colors.states.disabled};
    `} 


${({ black, outline }) =>
  black &&
  outline &&
  css`
    background: none;
    color: ${theme.colors.primary.black};
    border: 1px solid ${theme.colors.states.disabled};
    &:hover {
      background: ${theme.colors.secondary.blue600};
      border: 1px solid ${theme.colors.secondary.blue500};
      color: ${theme.colors.primary.bariBlue};
      & path {
        fill: ${theme.colors.primary.bariBlue};
      }
    }
    & path {
      fill: ${theme.colors.primary.black};
    }
  `}  

${({ white }) =>
  white &&
  css`
    background: ${theme.colors.primary.white};
    color: ${theme.colors.primary.black};
    border: 1px solid ${theme.colors.states.disabled};
    & svg {
      margin-left: 0;
    }
    &:hover {
      background-color: ${theme.colors.secondary.blue600};
      border: 1px solid ${theme.colors.secondary.blue500};
      color: ${theme.colors.primary.bariBlue};
      & path {
        fill: ${theme.colors.primary.bariBlue};
      }
    }
  `}  

${({ white, outline }) =>
  white &&
  outline &&
  css`
    background: none;
    color: ${theme.colors.primary.black};
    border: 1px solid ${theme.colors.states.disabled};
    &:hover {
      background: ${theme.colors.secondary.blue600};
      border: 1px solid ${theme.colors.secondary.blue500};
      color: ${theme.colors.primary.bariBlue};
      & path {
        fill: ${theme.colors.primary.bariBlue};
      }
    }
  `}    

${({ blue, disabled }) =>
  blue &&
  !disabled &&
  css`
    background: ${theme.colors.primary.bariBlue};
    color: ${theme.colors.primary.white};
    border: 1px solid ${theme.colors.primary.bariBlue};
    &:hover {
      color: ${theme.colors.primary.white};
      background-color: ${theme.colors.primary.black};
      border: 1px solid ${theme.colors.primary.black};
    }

    & path {
      fill: ${theme.colors.primary.white};
    }
  `}


  ${({ blue, hoverWhite }) =>
    blue &&
    hoverWhite &&
    css`
      background: ${theme.colors.primary.bariBlue};
      color: ${theme.colors.primary.white};
      border: 1px solid ${theme.colors.primary.bariBlue};
      &:hover {
        color: ${theme.colors.primary.black};
        background-color: ${theme.colors.primary.white};
        border: 1px solid ${theme.colors.primary.white};
      }

      & path {
        fill: ${theme.colors.primary.white};
      }
    `}  

${({ blue, outline }) =>
  blue &&
  outline &&
  css`
    background: none;
    color: ${theme.colors.primary.black};
    border: 1px solid ${theme.colors.states.disabled};
    &:hover {
      background: ${theme.colors.secondary.blue600};
      border: 1px solid ${theme.colors.secondary.blue500};
      color: ${theme.colors.primary.bariBlue};
      & path {
        fill: ${theme.colors.primary.bariBlue};
      }
    }
  `}    

  ${({ sideIcon }) =>
    sideIcon == sideButton.CENTER &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      width: 50px;
    `}  

    ${({ full }) =>
      full &&
      css`
        min-width: 100%;
        width: 100%;
      `}  
  
  ${({ disabled, black }) =>
    disabled &&
    css`
      cursor: not-allowed;
      background: ${black ? theme.colors.secondary.gray375 : 'transparent'};
      color: ${black ? theme.colors.secondary.gray600 : theme.colors.states.disabled};
      border: 1px solid ${theme.colors.states.disabled};
      & path {
        fill: ${theme.colors.states.disabled};
      }

      & rect {
        stroke: ${theme.colors.states.disabled};
      }

      &:hover {
        color: ${black ? theme.colors.secondary.gray600 : theme.colors.states.disabled};
        background: ${black ? theme.colors.secondary.gray375 : 'transparent'};
        border: 1px solid ${theme.colors.states.disabled};
        & path {
          fill: ${theme.colors.states.disabled};
        }
      }
    `}  


  ${({ blue, disabled, fillDisabled }) =>
    (blue || fillDisabled) &&
    disabled &&
    css`
      cursor: not-allowed;
      color: ${theme.colors.primary.white};
      background: ${theme.colors.states.disabled};
      border: 1px solid ${theme.colors.states.disabled};

      &:hover {
        background: ${theme.colors.states.disabled};
        border: 1px solid ${theme.colors.states.disabled};
        color: ${theme.colors.states.disabled};
        & path {
          fill: ${theme.colors.states.disabled};
        }
      }
    `}    

    ${({ full }) =>
      full &&
      css`
        padding: 18px 32px;
      `}      
    


`;

export const Content = styled.div<IButton>`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;

  ${({ full, sideIcon }) =>
    full &&
    !sideIcon &&
    css`
      justify-content: center;
      height: 60px;
    `}    
    
    ${({ full, sideIcon }) =>
      full &&
      sideIcon &&
      css`
        justify-content: space-between;
        height: 60px;
      `}         
    

  ${({ disabled }) =>
    disabled &&
    css`
      background: ${theme.colors.states.disabled};
      & path {
        fill: ${theme.colors.primary.white};
      }
      &:hover {
        background-color: ${theme.colors.states.disabled};
      }
    `}      

  ${({ sideIcon }) =>
    sideIcon == sideButton.LEFT &&
    css`
      flex-direction: row;
    `}

  ${({ sideIcon }) =>
    sideIcon == sideButton.RIGHT &&
    css`
      flex-direction: row-reverse;
    `}

    ${(props: IButton) =>
      props.sideIcon == sideButton.CENTER &&
      css`
        height: 32px;
        width: 32px;
      `}

`;
